const BASE = process.env.REACT_APP_API_URL || '';

async function req(method, path, body) {
  const opts = { method, 
                headers: { 'Content-Type': 'application/json',

                 },credentials: 'include', };
                 console.log(BASE + path);
  if (body) opts.body = JSON.stringify(body);
  const r = await fetch(BASE + path, opts);
  if (!r.ok) {
    const e = await r.json().catch(() => ({ error: r.statusText }));
    throw new Error(e.error || 'Request failed');
  }
  return r.json();
}

export const api = {
  // Invoices
  auth: {
    loginUrl: () => req('GET', '/auth/google'),
    me: () => req('GET', '/auth/me'),
    logout: () => req('POST', '/auth/logout'),
  },
  list: (params = {}) => req('GET', `/invoices?${new URLSearchParams(params)}`),
  get: (id) => req('GET', `/invoices/${id}`),
  create: (data) => req('POST', '/invoices', data),
  update: (id, data) => req('PUT', `/invoices/${id}`, data),
  del: (id) => req('DELETE', `/invoices/${id}`),
  deleteAll: (type) => req('DELETE', `/invoices?type=${type}`),
  deleteSubInvoice: (id, subIndex) => req('DELETE', `/invoices/${id}/sub-invoices/${subIndex}`),
  deleteAllSubInvoices: (id) => req('DELETE', `/invoices/${id}/sub-invoices`),
  xlsxUrl: (id) => `${BASE}/invoices/${id}/xlsx`,
  subInvoiceXlsxUrl: (id, subIndex) => `${BASE}/invoices/${id}/sub-invoices/${subIndex}/xlsx`,
  bulkDownloadUrl: (type) => `${BASE}/invoices/bulk/download?type=${type}`,

  // Receipts upload
  uploadReceipts: async (files, type, date) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f));
    fd.append('type', type);
    if (date) fd.append('date', date);
    const r = await fetch(`${BASE}/receipts/upload`, { method: 'POST', body: fd });
    if (!r.ok) {
      const e = await r.json().catch(() => ({ error: r.statusText }));
      throw new Error(e.error || 'Upload failed');
    }
    return r.json();
  },

  // Drive
  driveScan: (data) => req('POST', '/drive/scan', data),
  driveJobs: () => req('GET', '/drive/jobs'),
  driveJob: (id) => req('GET', `/drive/jobs/${id}`),
  deleteJob: (id) => req('DELETE', `/drive/jobs/${id}`),
  deleteAllJobs: () => req('DELETE', '/drive/jobs'),

  // Stats
  stats: (date) => req('GET', `/stats${date ? `?date=${date}` : ''}`),

  // Settings
  getSettings: () => req('GET', '/settings'),
  setSetting: (key, value) => req('POST', '/settings', { key, value }),

  // Ledger
  salesLedger: (month) => req('GET', `/ledger/sale${month ? `?month=${encodeURIComponent(month)}` : ''}`),
  purchaseLedger: (month) => req('GET', `/ledger/purchase${month ? `?month=${encodeURIComponent(month)}` : ''}`),
  deleteLedgerEntry: (type, data) => req('DELETE', `/ledger/${type}/entry`, data),
  deleteLedgerByDate: (type, date) => req('DELETE', `/ledger/${type}/date/${encodeURIComponent(date)}`),
  deleteLedger: (type) => req('DELETE', `/ledger/${type}`),

  // Health
  health: () => req('GET', '/health'),
};
